module.exports = __webpack_public_path__ + "static/img/sbm360.8523c0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sbm360.png
// module id = 703
// module chunks = 34